import { PrefetchKind } from 'next/dist/client/components/router-reducer/router-reducer-types';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

export const useAssetPagination = (totalPages: number) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [page, setPage] = useState(parseFloat(searchParams.get('page') ?? '1') ?? 1);

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams]
  );

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page') ?? '1') ?? 1;
    setPage(pageParam);
  }, [searchParams, setPage]);

  useEffect(() => {
    if (isNaN(totalPages)) {
      return;
    }

    if (page > totalPages) {
      router.push(`${pathname}?${createQueryString('page', totalPages.toString())}`);
    }
  }, [createQueryString, page, pathname, router, totalPages]);

  const onPageChange = useCallback(
    (newPage: number) => {
      if (newPage === page) {
        return;
      }

      setPage(newPage);
      router.push(`${pathname}?${createQueryString('page', newPage.toString())}`);
    },
    [createQueryString, pathname, page, router]
  );

  return { onPageChange, assetsPage: page };
};
